<template>
  <div id="app">
    <router-view></router-view>
    <el-backtop></el-backtop>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
      next;
    });
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
body {
  font-size: 16px;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
a {
  text-decoration: none;
}
:deep(.el-icon svg) {
  color: #248efb;
}
</style>
